import { Injectable } from "@angular/core";
import { SensorGroupType, SensorState } from "libs/domain/sensor/sensor.enums";

@Injectable({
  providedIn: 'root'
})
export class SensorUIService { 

  getSensorStateString(state: SensorState) {
    switch(state) {
      case SensorState.STOPPED:
        return "Parado";
      case SensorState.ACTIVE:
        return "Activo";
      case SensorState.ERROR_MINIMUM:
        return "Error mín.";
      case SensorState.ERROR_MAXIMUM:
        return "Error máx.";
      case SensorState.ERROR:
        return "Error";
      default:
        return "-";
    }
  }

  getSensorGroupRecord(groupType: SensorGroupType | null) {
    const GROUP_BADGE_UI: Record<SensorGroupType, any> = {
      NONE: { text: 'Sin grupo', color: 'neutral', variant: 'light' },
      SECTOR: { text: 'Sector', color: 'info', variant: 'light' },
      PARCEL: { text: 'Parcela', color: 'success', variant: 'light' },
      VISUALIZATION_GROUP: { text: 'G. Visualización', color: 'warning', variant: 'light' },
    };

    const key = (groupType ?? 'NONE') as SensorGroupType;
    return GROUP_BADGE_UI[key] ?? GROUP_BADGE_UI.NONE;
  }
}